export type TUser = {
  id: string;
  firstName: string;
  lastName: string;
  profileUrl?: string;
};

class User {
  public id: string;
  public firstName: string;
  public lastName: string;
  public profileUrl?: string;

  constructor(data: TUser) {
    this.id = data.id;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.profileUrl = data.profileUrl;
  }

  get fullName(): string {
    return [this.firstName, this.lastName].filter(Boolean).join(" ");
  }
}

export default User;
